<div class="flex gap-5 flex-1">
  <div>
    <rk-image-upload
      (fileSelected)="onRawImageSelected($event)"
      [deleteButton]="false"
      [width]="'200px'"
      [aspectRatio]="'1/1'"
      [compactLayout]="true"
    ></rk-image-upload>
  </div>
  <div class="pr-10 max-w-[436px]">
    <div class="font-bold text-lg mb-[10px]">
      {{ 'assets.app-logo' | translate }}
    </div>
    <div class="mb-4">{{ 'assets.app-logo-explained' | translate }}</div>
    <rk-infobox [type]="'info'" class="w-fit">
      <div class="font-bold text-sm">
        <fa-icon [icon]="'info-circle'"></fa-icon>
        {{ 'assets.restrictions' | translate }}
      </div>
      <div [innerHTML]="'assets.app-logo-size' | translate"></div>
    </rk-infobox>
  </div>
</div>
